import { UIIcon } from '../config/icons';
import { aTrackVideo } from '../lib/mdl/a-track';
import { cCityBySlug } from '../lib/mdl/c-city';
import { CHEvent, chEventBySlug, chEventTrackProperties, CHEventVideo, chEventVideoIsAvailable } from '../lib/mdl/c-event-home';
import { cVideoWatch } from '../lib/mdl/c-video-home';
import { the_login_scope } from '../lib/me/login';
import { onDetach } from '../lib/ui/attach';
import { uiSetBG } from '../lib/ui/bg';
import { UIButton } from '../lib/ui/component/button';
import { UIHLSPlayer } from '../lib/ui/component/hls-player';
import { $el } from '../lib/ui/elements';
import { UIScreen } from '../lib/ui/screen';
import { UIView, UIViewSpec } from '../lib/ui/view';
import { $analytics } from '../lib/y/analytics';
import { $on } from '../lib/y/events';
import { $location } from '../lib/y/location';

class VideoPlayer extends UIView {
    constructor(event: CHEvent, video: CHEventVideo, master_url: string, position?: number) {
        super('div', 'ui-video-player m-fs');

        const image = $el.DIV('r-layer');
        uiSetBG(image, { media: event.picture_ids[0] });
        const video_player = new UIHLSPlayer;
        video_player.classList.add('r-layer');
        this.ui_add([video_player, image]);

        const cover = $el.DIV('r-cover r-layer', [
            new UIButton({
                icon: UIIcon.PLAY, kind: 'k-square', classes: 'm-round ui-tint-reverse', on_click: () => {
                    video_player.play().then(() => {
                        const properties = chEventTrackProperties(event);
                        $analytics.track('Play VOD', properties);

                        image.remove();
                        cover.remove();
                    });
                }
            })
        ]);

        onDetach(this, () => {
            aTrackVideo(event.id, video.id, undefined, 0, video_player.position);
        });

        this.ui_add(cover);

        $on(video_player, 'play', () => {
            aTrackVideo(event.id, video.id, 'video.play', 0, video_player.position);
        })
        $on(video_player, 'pause', d => {
            aTrackVideo(event.id, video.id, 'video.pause', d, video_player.position);
        })
        $on(video_player, 'ended', d => {
            aTrackVideo(event.id, video.id, 'video.ended', d, video_player.position);
        })
        $on(video_player, 'played', d => {
            aTrackVideo(event.id, video.id, undefined, d, video_player.position);
        })

        video_player.load(master_url);

        if(position)
            video_player.position = position;
    }
}

export class HomePlayerScreen extends UIScreen {
    constructor(private _city_slug: string, private _slug: string, private _master_url?: string, private _position?: number) {
        super();
    }

    protected override async fillContent(content: UIViewSpec) {
        const city_slug = this._city_slug;
        const slug = this._slug;
        const master_url = this._master_url;
        const position = this._position;

        const back_to_event = () => {
            $location.navigate(['event', city_slug, slug]);
        }

        const city = cCityBySlug(this._city_slug)!;
        const event = await chEventBySlug(city.id, this._slug);
        const video = event.videos[0];
        if(!chEventVideoIsAvailable(video) || (!the_login_scope && !video.is_open)) {
            back_to_event();
            return;
        }

        if(master_url) {
            content.ui_add(new VideoPlayer(event, video, master_url, position));
        } else {
            cVideoWatch(event.id, video.id).then(r => {
                if(r.can_watch && r.live) {
                    content.ui_add(new VideoPlayer(event, video, r.master_url, r.position));
                } else {
                    back_to_event();
                }
            });
        }
    }
}
